import { getUrlParameter } from '../utils/helper';
const bootstrap = {
    API_URL: "https://ew.narendramodi.in/api",
    NM_API_URL: "https://api.narendramodi.in/api/"

}

const currentURL = function() {

}
var appclient = {}
appclient['nm_api_token'] = "ddd913e233f8bb3549b4a528278d8815";
appclient['api_token'] = "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga";
appclient['share_text'] = "https://nm4.in/dnldapp";

//var geocode ={}
//geocode['api_key'] = "AIzaSyDfa7up2oZhqjM_9nE7vA72q3UQTwSPCME";

//read url parameters and export
var address = window.location.href;
var urlparams = "";
if ( window.localStorage.getItem( urlparams ) ) {
    urlparams = "?" + window.localStorage.getItem( "urlparams" );
}

if ( address.indexOf( "userid" ) != -1 ) {
    var urlparamsdata = address.split( "?" );
    var ufirstparams = urlparamsdata[0].replace("lang_hi","");
    window.localStorage.setItem( "urlparams", urlparamsdata[1] );
    urlparams = "?" + urlparamsdata["1"];
    if ( urlparamsdata[0].indexOf( "lang_" ) != -1 ) {
        var parts = urlparamsdata[0].split( "/" );
        var last = parts[parts.length - 1];
        if ( last.indexOf( "lang_" ) != -1 ) {
            var laguage_string = last.split( "_" );
            var neur = urlparams.replace("&lang=en","");
            urlparams = neur + "&lang=" + laguage_string[1];
            var loc = ufirstparams + urlparams;
            window.location = (loc);
        }
    }
}
export default currentURL;
export { currentURL, bootstrap, appclient, urlparams}